import { FC, ReactNode } from 'react';
import classNames from 'classnames';

interface Props {
  step: number;
  title: string;
  description?: string;
  muted?: boolean;
  actions?: ReactNode;
}

const BuilderStepHeading: FC<Props> = ({
  step,
  title,
  description,
  muted = false,
  actions,
}) => (
  <div className="mb-4">
    <div
      className={classNames(
        'flex items-center justify-between gap-3',
        muted && 'opacity-50',
      )}
    >
      <div className="flex items-center gap-2.5">
        <span className="text-sm flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primary-125 font-bold text-white">
          {step}
        </span>
        <span className="text-body font-medium leading-6 text-secondary-150">
          {title}
        </span>
      </div>
      {actions}
    </div>
    {description ? (
      <p className="mt-2 whitespace-pre-line pl-[38px] text-small-caption text-neutral-110">
        {description}
      </p>
    ) : null}
  </div>
);

export default BuilderStepHeading;
